import { RedirectToUserProfile, UserButton, useUser } from "@clerk/clerk-react";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ANONYMOUS_BASE_URL } from "../../constant/endpoint";
import { pageUrl } from "../../constant/pageurl";
import PaymentButton from "../../subscription/PaymentButton";
import { FeedbackCards } from "../message-cards/FeedbackCards";
import "./dashboard.css";
import { Menu } from "./Menu";
import { SmileyReactions } from "./smiley-helper/SmileyReactions";

export const Dashboard = () => {
  const user = useUser();
  const { username, id } = useUser();
  const email = user.emailAddresses[0].emailAddress;
  const [userFeedbacks, setUserFeedbacks] = useState(null);

  useEffect(() => {
    const retrieveFeedback = async () => {
      const payload = {
        username,
      };
      const { data } = await axios.post(
        `${ANONYMOUS_BASE_URL}/feedbacks/retrieve`,
        payload
      );
      setUserFeedbacks(data.data);
    };
    // Get user feedbacks
    retrieveFeedback();
  }, [username]);

  // starred feedbacks
  const showStarredFeedbacks = () => {
    const starredFeedbacks = userFeedbacks.filter(
      (feedback) => feedback.starred === true
    );
    // Display starred feedbacks
    setUserFeedbacks(starredFeedbacks);
  };

  // tell user to fill their username
  if (!username) {
    // this is rendering twice, need a fix
    alert("Please update your username to access this page");
    // take them to clerk profile managment
    return <RedirectToUserProfile />;
  }

  return (
    <React.Fragment>
      <div className="dashboard-container">
        <aside className="container-fluid">
          <Menu cb={showStarredFeedbacks} />
        </aside>

        <section className="container-fluid feedback-stack">
          <div className="fixed-heading-wrap">
            <div className="heading-caption">
              <Link to={pageUrl.HOMEPAGE} className="heading-title">
                {" "}
                Anonymous Feedbacks{" "}
              </Link>
              <h1 className="heading-greet"> Welcome back, {username}</h1>
            </div>
            <UserButton />
          </div>
          {userFeedbacks?.length === 5 && (
            <p className="limit-alert">
              Feedback limit reached,{" "}
              <abbr title="Subscribed? This message will disappear after you got a new feedback">
                <PaymentButton username={username} email={email} id={id} />
              </abbr>
            </p>
          )}
          {userFeedbacks &&
            userFeedbacks
              .sort((a, b) => b.__createdtime__ - a.__createdtime__)
              .map(({ feedback, smiley, __createdtime__, id, starred }) => {
                return (
                  <FeedbackCards
                    key={id}
                    id={id}
                    feedback={feedback}
                    smiley={smiley}
                    givenDate={__createdtime__}
                    starred={starred}
                    premiumActive={userFeedbacks?.length > 5 ? true : false}
                  />
                );
              })}

          {/* When data is been fetched */}
          {userFeedbacks === null && (
            <div className="feedback-card lg-info-card card h-50 d-flex justify-content-center mt-lg-3 mb-5">
              <p>BayBot is fetching your feedback 🏃‍♂️</p>
            </div>
          )}

          {/* If there is no userfeedback from the backend */}
          {userFeedbacks?.length === 0 && (
            <div className="feedback-card lg-info-card card h-50 d-flex justify-content-center mt-lg-3 mb-5">
              <p>
                You do not have any feedbacks yet 😢. share your link to get
                feedbacks
              </p>
            </div>
          )}
        </section>

        <aside className="container-fluid">
          <SmileyReactions userFeedbacks={userFeedbacks} />
        </aside>
      </div>
    </React.Fragment>
  );
};
